<div class="consultation-request" *ngIf="!loadingService.isLoading">
  <div class="container consultation-request-container" *ngIf="errorMessage">
    <div class="columns is-centered mx-0">
      <div class="column is-10">
        <div class="my-4">
          <app-error-notification classes="is-fullwidth notification-error p-3 has-text-black mb-5">
            <p class="is-inline" [innerHTML]="errorMessage"></p>
          </app-error-notification>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!errorMessage">
    <app-consultation-request-header></app-consultation-request-header>
    <div class="container consultation-request-container mt-2" data-qa-id="GLP-1 Renewal Form">
      <div class="columns is-centered mx-0">
        <div class="column is-10 pt-0" id="consultation-request-container">
          <div class="my-4">
            <app-consultation-request-patient-info
              [patientInfoForm]="patientInfoForm"
            ></app-consultation-request-patient-info>
          </div>
          <div class="my-4">
            <app-card
              title="Medical Questionnaire"
              headerClasses="p-4 has-text-weight-bold is-size-4-mobile card-header-title"
              contentClasses="p-4"
            >
              <app-dynamic-questionnaire-form
                data-qa-id="Medical Questions Form"
                #medicalQuestionsForm
                *ngIf="medicalQuestionIds.length"
                [storageKey]="consultationRequestTreatmentType"
                [indexedDbName]="indexedDbName"
                [questionIds]="medicalQuestionIds"
                [externalData]="externalData"
              ></app-dynamic-questionnaire-form>
              <app-medical-history-questions
                #medicalHistoryQuestionsForm
                [allergiesDetailsInitialValue]="consultationRequest?.allergies"
                [medicationDetailsInitialValue]="consultationRequest?.prescriptions"
                [otherConditionsDetailsInitialValue]="consultationRequest?.health_info"
              ></app-medical-history-questions>
              <app-consultation-request-address
                [title]="consultationRequestAddressTitle"
                [addressForm]="addressForm"
                hint="Your GLP-1 medication will be shipped to the address above."
              ></app-consultation-request-address>
              <app-glp1-upgrade-dosage-upsell
                #upgradeDosageUpsell
                *ngIf="glp1MedicationTestId"
                [testId]="glp1MedicationTestId"
              ></app-glp1-upgrade-dosage-upsell>
              <app-dynamic-questionnaire-form
                class="vertical-options upsell-questions"
                data-qa-id="Upsell Questions Form"
                #upsellQuestionsForm
                *ngIf="upsellIds.length"
                [storageKey]="QuestionnaireStorageKeys.Upsells"
                [questionIds]="upsellIds"
                [externalData]="externalData"
              ></app-dynamic-questionnaire-form>
            </app-card>
          </div>
          <div class="my-4">
            <p
              *ngIf="shouldDisplayBottomError"
              data-qa-id="Questionnaire Continue Button Error"
              class="has-text-centered has-text-weight-ultrabold mb-3 has-text-danger"
            >
              {{ submissionError || responseError }}
            </p>
            <button
              (click)="continue()"
              class="continue-button button is-rounded is-primary"
              data-qa-id="Questionnaire Continue Button"
              [disabled]="isProcessing || continueErrorMessage"
            >
              <i *ngIf="isProcessing" class="fa fa-spin fa-spinner"></i>
              <span *ngIf="!isProcessing">Continue</span>
            </button>
            <p
              data-qa-id="Continue Button Error Message"
              *ngIf="continueErrorMessage"
              class="has-text-danger has-text-centered mt-3"
            >
              {{ continueErrorMessage }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
